export const PENDING = "PENDING";
export const IN_PROGRESS = "IN_PROGRESS";
export const IN_REVIEW = "IN_REVIEW";
export const REJECTED = "REJECTED";
export const COMPLETED = "COMPLETED";
export const CANCELLED = "CANCELLED";
